import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';
import { useFormElement } from '../../composables/useFormElement';
import { makeUseFormElementEmits, makeUseFormElementProps } from '../../composables/useFormElementInterfaces';
import { FieldModel } from '../../interfaces';
import { useBaseFieldValues } from '../../composables/useBaseFieldValues';
// importing directly to avoid non-extracted css issues from built code
import VueSlider from 'vue-slider-component';


export default /*#__PURE__*/_defineComponent({
  __name: 'SliderFormField',
  props: makeUseFormElementProps<FieldModel, number>(),
  emits: makeUseFormElementEmits<number>(),
  setup(__props, { emit }) {

const props = __props;





const inputValue = ref('');

const inputEl = ref<HTMLInputElement>();

const formElement = useFormElement({
  emit,
  props,
});

const { fieldErrorsShown, readonly, inputErrorClass, inputClass } = useBaseFieldValues(formElement);

const { modelStateRef, model, field, getSlotName, getModelState, setValue } = formElement;

const cappedValue = computed(() => {
  if (dataPoints.value) {
    return field.value.$model;
  }
  return Math.max(min.value, Math.min(max.value, field.value.$model));
});

const max = computed(() => {
  const max = getModelState('max', 100);
  return getModelState('maxValue', max);
});

const min = computed(() => {
  const min = getModelState('min', 0);
  return getModelState('minValue', min);
});

const valueToInputFn = modelStateRef('valueToInputFn', (val: number) => val.toString());

const inputToValueFn = modelStateRef('inputToValueFn', (val: string) => parseFloat(val));

const withMathFloor = modelStateRef('withMathFloor', true);

const interval = modelStateRef('interval', 1);

const dataPoints = modelStateRef('data', undefined);

function setInputValue(event: any) {
  if (!event.target) return;

  let value!: number;

  try {
    value = inputToValueFn.value(event.target.value);
  } catch (e) {
    return;
  }

  if (dataPoints.value) {
    if (dataPoints.value.includes(+value)) {
      setValue(+value);
    } else {
      const dataSorted = (dataPoints.value as number[]).sort();
      for (let i = 0; i < dataSorted.length; i += 1) {
        if (dataSorted[i] > +value || i === dataSorted.length - 1) {
          setValue(+dataSorted[i]);
          return;
        }
      }
    }
  } else {
    const constrainedValue = Math.max(min.value, Math.min(max.value, value));

    if (withMathFloor.value) {
      setValue(Math.floor((constrainedValue - min.value) / interval.value) * interval.value + min.value);
    } else {
      setValue(((constrainedValue - min.value) / interval.value) * interval.value + min.value);
    }
  }
}

function updateValueFromModel() {
  inputValue.value = valueToInputFn.value(field.value.$model);
}

watch(
  () => field.value.$model,
  () => {
    if (inputEl.value !== document.activeElement) {
      updateValueFromModel();
    }
  },
  { immediate: true }
);

updateValueFromModel();

return { __sfc: true,props, emit, inputValue, inputEl, formElement, fieldErrorsShown, readonly, inputErrorClass, inputClass, modelStateRef, model, field, getSlotName, getModelState, setValue, cappedValue, max, min, valueToInputFn, inputToValueFn, withMathFloor, interval, dataPoints, setInputValue, updateValueFromModel, VueSlider }
}

})